export default __webpack_public_path__ + "static/media/Request_Demo.e0f55af6.png";